import moment from 'moment'

const items = state => state.items
const pendingItems = state => {        
  let listPendingMeetings = []
  let listMonth = []
  for (let i = 0; i < state.items.length; i++) {
    const month = moment(state.items[i].start_at).month() + 1
    const index = _.findIndex(listMonth, n => n === month)
    if (index === -1) listMonth.push(month)
  }

  listMonth.reverse()

  for(let i = 0; i < listMonth.length; i++) {
    listPendingMeetings.push({month: listMonth[i], meetings: []})
  }

  for (let i = 0; i < listPendingMeetings.length; i++) {
    for (let j = 0; j < state.items.length; j++) {
      if (moment(state.items[j].start_at).month() + 1 === listPendingMeetings[i].month) {
        listPendingMeetings[i]['meetings'].push(state.items[j])
      }
    }
  }
  return listPendingMeetings
}
const categories = state => state.categories
const reservationCategories = state => state.categories.filter(n => n.type === 'reservation')
const searchParams = state => state.searchParams

export default {
  items,
  pendingItems,
  categories,
  reservationCategories,
  searchParams
}



// WEBPACK FOOTER //
// ./src/store/modules/meetings/getters.js